import script from "./SubmitPaper.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitPaper.vue?vue&type=script&setup=true&lang=js"

import "./SubmitPaper.vue?vue&type=style&index=0&id=0af95a1b&lang=scss"

const __exports__ = script;

export default __exports__